import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'requirement',
    viewPath: props.viewPath,
  })

  return function onChange(action) {
    change(next => {
      next.new_task = {
        ...next.new_task,
        actions: [action],
      }
    })
  }
}
